import * as React from 'react';
import Container from '../../../containers/user/teachers/editTeacherContainer';

export default function () {
  return (
    <Container />
  );
}
